import React, { Component } from "react"
import PropTypes from "prop-types"
import rulesRunner from "react-jsonschema-form-conditionals/lib/rulesRunner"
import { deepEquals } from "react-jsonschema-form/lib/utils"

export default (Engine, extraActions) => WrappedComponent => {
  return class extends Component {
    static propTypes = {
      schema: PropTypes.any,
      uiSchema: PropTypes.any,
      rules: PropTypes.any,
    }

    constructor(props) {
      super(props)
      this.props = this.validateProps(props)

      this.handleChange = this.handleChange.bind(this)
      this.updateConf = this.updateConf.bind(this)
      this.runRules = this.createRuleRunner()

      let { formData = {}, schema, uiSchema } = this.props

      this.shouldUpdate = false
      this.state = { schema, uiSchema, formData }
      this.updateConf(formData)
    }

    validateProps(props) {
      // TODO: Props should be fixed at the source, not when rendering
      if (props?.schema?.properties) {
        const steps = props.schema.properties
        for (var stepName in steps) {
          const step = steps[stepName]
          // Let's make sure we only allow required fields that do exist in properties
          // TODO: This is fixed now, but some entries might still be erroneous
          if (step.required) {
            const validated = []
            for (var i in step.required) {
              const key = step.required[i]
              if (step.properties[key]) {
                validated.push(key)
              }
            }
            props.schema.properties[stepName].required = validated
          }
        }
      }
      return props
    }

    createRuleRunner() {
      const { schema, uiSchema, rules } = this.props
      const engine = new Engine(rules)
      return rulesRunner(schema, uiSchema, rules, engine, extraActions)
    }

    componentWillReceiveProps(nextProps) {
      let formDataChanged =
        nextProps.formData &&
        !deepEquals(nextProps.formData, this.state.formData)
      if (formDataChanged) {
        this.updateConf(nextProps.formData)
        this.shouldUpdate = true
      } else {
        this.shouldUpdate =
          this.shouldUpdate ||
          !deepEquals(
            nextProps,
            Object.assign({}, this.props, { formData: nextProps.formData })
          )
      }
    }

    updateConf(formData) {
      return this.runRules(formData).then(conf => {
        const { schema, uiSchema, formData } = conf
        const newState = { schema, uiSchema, formData }

        if (!deepEquals(newState, this.state)) {
          this.shouldUpdate = true
          this.setState(newState)
        }

        return conf
      })
    }

    handleChange(change) {
      let updTask = this.updateConf(change.formData)

      let { onChange } = this.props
      if (onChange) {
        updTask.then(conf => {
          let updChange = Object.assign({}, change, conf)
          onChange(updChange)
        })
      }
    }

    shouldComponentUpdate() {
      if (this.shouldUpdate) {
        this.shouldUpdate = false
        return true
      }
      return false
    }

    render() {
      // Assignment order is important
      let formConf = Object.assign({}, this.props, this.state, {
        onChange: this.handleChange,
      })
      return <WrappedComponent {...formConf} />
    }
  }
}
